export var DateInputError;

(function (DateInputError) {
  DateInputError["InvalidDate"] = "INVALID_DATE";
  DateInputError["IncorrectFormat"] = "INCORRECT_FORMAT";
})(DateInputError || (DateInputError = {}));